import { render, staticRenderFns } from "./BindDTQModal.vue?vue&type=template&id=2a56b110&scoped=true"
import script from "./BindDTQModal.vue?vue&type=script&lang=js"
export * from "./BindDTQModal.vue?vue&type=script&lang=js"
import style0 from "./BindDTQModal.vue?vue&type=style&index=0&id=2a56b110&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a56b110",
  null
  
)

export default component.exports